import { createRef } from "react";

const refStore = {
  rateLimitTimerRef: createRef()
};

export default refStore;